<div class="wrap">
  <div class="btn_action">
    <div class="btn">
      <!-- <button [routerLink]="['/licence']" routerLinkActive="router-link-active"> -->
      <button *ngIf="linkLicence" (click)="showMySkills()">
        <div class="img_btn"><img src="assets/img/ffv_icone.svg" alt="trophy_wall"></div>
        <span>Mes compétences Voile</span>
      </button>
      <button (click)="showMyWallOfTrophy()" *ngIf="linkLicence">
        <div class="img_btn"><img src="assets/img/icon-white/courses.svg" alt="trophy_wall"></div>
        <span>Mes trophées</span>
      </button>
      <button (click)="link()">
        <div class="img_btn"><img src="assets/img/icon-white/license.svg" alt="Ma_licence"></div>
        <span *ngIf="linkLicence">Ma Licence</span>
        <span *ngIf="!linkLicence">Lier ma licence</span>
      </button>
      <button [routerLink]="['/choice-persona']" routerLinkActive="router-link-active">
        <div class="img_btn"><img src="assets/img/icon-white/profil.svg" alt="Ma_licence"></div>
        <span>Quel marin suis-je ?</span>
      </button>
      <button (click)="getShowValue()" *ngIf="userInfos?.is_social_login == 'Password'">
        <div class="img_btn"><img src="assets/img/icon-white/lock_white.svg" alt="modifier mot de passe"></div>
        <span>Modifier le mot de passe</span>
      </button>
      <button [routerLink]="['/regates']" routerLinkActive="router-link-active" *ngIf="linkLicence">
        <div class="img_btn"><img src="assets/img/icon-white/courses.svg" alt="mes régates"></div>
        <span>Mes régates</span>
      </button>
      <button (click)="showMyClub()" *ngIf="linkLicence">
        <div class="img_btn"><img src="assets/img/icon-white/clubs.svg" alt="mes clubs"></div>
        <span>Mon Club</span>
      </button>
      <button *ngIf="linkLicence" (click)="unlinkLicence()">
        <fa-icon [icon]="faUnlink"></fa-icon>
        <span>Dissocier ma licence</span>
      </button>
    </div>
    <button class="logout" (click)="logout()">Déconnexion</button>
    <div class="unsubscribe_rgpd">
      <span (click)="openDialogUnsubscription()" class="unsubscribe">Se désinscrire</span>
      <span>-</span>
      <span class="cond" (click)="goToConditions()">Politique des données personnelles</span>
    </div>
    <div class="contact">
      <fa-icon [icon]="faEnvelope"></fa-icon>
      <a href="mailTo:contact@ffvoile.fr">Nous contacter</a>
    </div>
  </div>
</div>